import { Button } from '@material-ui/core';
import React from 'react';
import RTVDialog from './dialogs/RTVDialog';

export default ({ rtvDialogProps, childrenStyle = {}, children }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <RTVDialog
        open={open}
        onClose={() => setOpen(false)}
        actionSection={
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(false)}
          >
            OK
          </Button>
        }
        {...rtvDialogProps}
      />
      {React.cloneElement(children, {
        onClick: () => setOpen(true),
        style: { cursor: 'pointer', ...childrenStyle }
      })}
    </>
  );
};
